export default __webpack_public_path__ + "static/media/GB.a33c62b4.png";